import React from 'react';
import { LabeledValue } from 'antd/lib/select';
import { FormattedMessage } from 'react-intl';
import differenceInMilliseconds from 'date-fns/differenceInMilliseconds';
import { SESSION_EXPIRATION_DELAY } from 'src/constants/index';
import differenceInDays from 'date-fns/differenceInDays';
import { creatingArrayWithNumber } from './common';
import format from 'date-fns/format';

const MAX_YEARS = 20;
const ZERO = 0;
const ONE = 1;
const TEN = 10;
const isoFormat = 'yyyy-MM-dd';
const startTime = 'T00:00:01.000Z';

export const getMonths = (): LabeledValue[] => {
  return [
    { value: 0, label: <FormattedMessage id="january" /> },
    { value: 1, label: <FormattedMessage id="february" /> },
    { value: 2, label: <FormattedMessage id="march" /> },
    { value: 3, label: <FormattedMessage id="april" /> },
    { value: 4, label: <FormattedMessage id="may" /> },
    { value: 5, label: <FormattedMessage id="june" /> },
    { value: 6, label: <FormattedMessage id="july" /> },
    { value: 7, label: <FormattedMessage id="august" /> },
    { value: 8, label: <FormattedMessage id="september" /> },
    { value: 9, label: <FormattedMessage id="october" /> },
    { value: 10, label: <FormattedMessage id="november" /> },
    { value: 11, label: <FormattedMessage id="december" /> },
  ];
};

export const getTimeout = (expireDate: string): number => {
  const date = new Date(expireDate);
  const now = new Date();
  return differenceInMilliseconds(date, now) - SESSION_EXPIRATION_DELAY;
};

export const getNights = (dateFrom: string, dateTo: string): number => {
  return differenceInDays(new Date(dateTo), new Date(dateFrom));
};

export const getOptionsYear = (): number[] => {
  const date = new Date();
  const currentYear = date.getFullYear();

  return creatingArrayWithNumber(MAX_YEARS, currentYear);
};

export const formatDateCheckInOut = (date: string, dateFormat: string): string => {
  return format(getDateCheckInOut(date), dateFormat);
};

export const getDateCheckInOut = (date: string): Date => {
  if (!(date?.length >= 10)) {
    return undefined;
  }

  const [year, month, day] = date.substr(ZERO, TEN).split('-');
  return new Date(Number(year), Number(month) - ONE, Number(day));
};

export const getDateCheckInOutISOString = (date: Date): string => {
  return date === undefined || date === null
    ? undefined
    : format(date, isoFormat) + startTime;
};